// src/components/ModuleProtectedRoute.tsx
import { useAuth } from "../src/hooks/useAuth";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { ReactNode } from "react";
import { useEffect, useState } from "react";

interface ModuleProtectedRouteProps {
  moduleId: string;
  children?: ReactNode;
  redirectPath?: string;
}

const ModuleProtectedRoute = ({
  moduleId,
  redirectPath = '/',
  children,
}: ModuleProtectedRouteProps) => {
  const { isAuthenticated, isLoading, hasModuleAccess } = useAuth();
  const location = useLocation();
  const [isReady, setIsReady] = useState(false);
  useEffect(() => {
    if (!isLoading) {
      setIsReady(true);
    }
  }, [isLoading]);

  if (!isReady) {
    return <div></div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (!hasModuleAccess(moduleId)) {
    return <Navigate to={redirectPath} state={{ from: location }} replace />;
  }

  return <>{children ? children : <Outlet />}</>;
};

export default ModuleProtectedRoute;